// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumPosts__list":"th_a bih_rc bih_qx bih_xr","ForumPosts__contest":"th_b bih_hq","ForumPosts__counselling":"th_c"};